import React, { useEffect, useState } from 'react'
import './Reports.css'; 
import { Col, Row, Container, Card, Button } from 'react-bootstrap'; 
import { Link, useSearchParams } from 'react-router-dom';  

import { GetCustomerReport } from '../../apis/ReportsAPI';
import * as BsIcons from "react-icons/bs";

export default function Reports() { 
    const [searchParams, setSearchParams] = useSearchParams();
    const mappingid = searchParams.get('id');
    const [reportdata, setReportData] = useState([]); 

    useEffect(() => {
        async function GetReporData(){
          var result = await GetCustomerReport({mappingid});
          var data = result.data; 
          setReportData(data.item1); 
        }
        GetReporData();
      },[])
      //
  return (
    <>
        <Container className='mb-5'>
                <Row className='page-head-row'>
                    <Col lg={6} md={6} sm={12}>
                        <div className='page-title'> 
                        </div>
                    </Col>
                    <Col lg={6} md={6} sm={12}>
                        <div className='search-filter'>
                             
                        </div>
                    </Col>
                </Row> 

                <Row>
                    <Col lg={12}>
                        <Card className='orderdetails-card'>
                            <div className="card-head">
                                <div className="card-title h5"><span>Report No:</span> {reportdata.reportCustomerMappingId}</div>
                                <Link to='/Customer/Reports' className='back-btn'><BsIcons.BsArrowLeft /></Link>
                            </div> 
                            <Row>
                                <Col lg={6} md={12}>
                                    <div className='orderdetails-info'>
                                        <div className='orderdetails-info-list'><span>Customer Name:</span> {reportdata.customerName}</div>
                                        <div className='orderdetails-info-list'><span>Requestor Name:</span> {reportdata.reportName}</div>
                                        <div className='orderdetails-info-list'><span>Applicant:</span> {reportdata.reportDescription}</div>
                                        <div className='orderdetails-info-list'><span>Completion Date:</span> {reportdata.reportPrice}</div>
                                        <div className='orderdetails-info-list'><span>Created Date:</span> {reportdata.customPrice}</div>
                                        <div className='orderdetails-info-list'><span>Updated Date:</span> {reportdata.taxStatus}</div>
                                        <div className='orderdetails-info-list'><span>Total Rows:</span> {reportdata.reportTemplateId}</div> 
                                    </div>
                                </Col>
                                <Col lg={6} md={12}>
                                    <div className='orderdetails-info'>
                                        {/* <div className='orderdetails-info-list'><span>Other Instructions:</span> {reportdata.customerId}</div>
                                        <div className='orderdetails-info-list'><span>Form(s):</span> <p><Link>File Name</Link></p></div>
                                        <div className='orderdetails-info-list'><span>Attachment(s):</span> <p><Link>File Name</Link></p></div>   */}
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col className='text-center mt-5'>
                                    <Button type='button' className='view-report-btn'>View Report</Button> 
                                </Col>
                            </Row> 
                        </Card>    
                    </Col> 
                </Row>
            </Container>
    </>
  )
}
